import React from "react";
import { ReactComponent as PatientLoaderIcon } from "../../assets/icons/PatientLoader.svg";

const PatientLoader = ({ text = "Content Loading ...", showText = true }) => {
  return (
    <div className="patient-loader-wrapper p-5">
      <PatientLoaderIcon className="patient-spinner" />
      {showText && <span>{text}</span>}
    </div>
  );
};

export default PatientLoader;
